// The three DOM helpers this client actually needs. Everything is built with these rather than
// with innerHTML, so no server or player supplied string is ever parsed as markup.

export function el(tag, options = {}, children = []) {
  const node = document.createElement(tag);
  const { className, text, ...attributes } = options;
  if (className) node.className = className;
  if (text !== undefined) node.textContent = text;
  for (const [name, value] of Object.entries(attributes)) {
    if (name.startsWith('on') && typeof value === 'function') {
      node.addEventListener(name.slice(2).toLowerCase(), value);
    } else if (value !== undefined && value !== null && value !== false) {
      node.setAttribute(name, value === true ? '' : value);
    }
  }
  for (const child of [children].flat()) {
    if (child) node.append(child);
  }
  return node;
}

export function clear(node) {
  node.replaceChildren();
  return node;
}

export function byId(id) {
  const node = document.getElementById(id);
  if (!node) throw new Error(`missing element #${id}`);
  return node;
}
